import type { ProviderModel } from '@/adapters/apiv1.g';
import type { LogoAsset } from '@/types/shared/logo';
import type { Provider } from '@/types/core/provider';
import type { UUID } from '@/utils/uuid';

type LogoInput = { light: string; dark: string };

function extractLogo(value?: Partial<LogoInput>): LogoAsset | undefined {
  const light = value?.light?.trim();
  const dark = value?.dark?.trim();
  if (light && dark) {
    return {
      light,
      dark,
    };
  }

  return undefined;
}

export function extractProvider(model: ProviderModel): Provider {
  const logo = extractLogo({
    light: model.logo_light_uri ?? '',
    dark: model.logo_dark_uri ?? '',
  });

  return {
    _rev: model._rev,
    id: (model.provider_id ?? '') as UUID,
    tenantId: model.tenant_id as UUID | undefined,
    name: model.name ?? '',
    manifestVersion: model.manifest_version ?? undefined,
    logo,
    description: model.description ?? '',
    status: model.status ?? '',
    isSystem: model.is_system,
    isInternal: model.is_internal,
  };
}
